import { StyleSheet, Dimensions } from 'react-native'

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes'

const { height: SCREEN_HEIGHT } = Dimensions.get('window')

export default StyleSheet.create({
  container: withTray => ({
    marginTop: 31.4,
    marginHorizontal: 16.6,
    paddingBottom: withTray ? 130 : 30,
  }),
  title: theme => ({
    color: theme.colors.headerColor,
    fontSize: 25,
    fontFamily: Fonts.type.VodafoneLt,
    lineHeight: 31.2,
  }),
  cardContainerStyle: theme => ({
    marginTop: 18.7,
    padding: 16.5,
    backgroundColor: theme.colors.cardBackgroundColor,
    borderRadius: 6,
    shadowColor: 'rgba(0, 0, 0, 0.16)',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowRadius: 8,
    shadowOpacity: 1,
    elevation: 2,
    alignItems: 'center',
  }),
  serviceTypeImageStyle: {
    marginBottom: 16.4,
    marginTop: 8.4,
  },
  serviceTypeTextStyle: theme => ({
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: 25,
    color: theme.colors.headerTitleColor,
  }),
  storeInfoContainerStyle: {
    marginBottom: 17,
  },
  dateTextStyle: theme => ({
    fontSize: 16.6,
    color: theme.colors.headerTitleColor,
    ...Fonts.type.bold,
  }),
  helperTextContainerStyle: {
    width: '100%',
  },
  helperTextStyle: theme => ({
    fontSize: 14.6,
    color: theme.colors.headerTitleColor,
    marginTop: 16.1,
    lineHeight: 17,
  }),
  hyperLinkTextStyle: {
    textDecorationLine: 'underline',
  },
  seperatorStyle: theme => ({
    backgroundColor: theme.colors.borderColorEight,
    height: 1,
    width: '100%',
    marginVertical: 18,
  }),
  confirmButtonStyle: {
    width: '100%',
  },
  modalHeaderStyle: {
    marginHorizontal: 0
  },
  modalView: {
    height: SCREEN_HEIGHT / 1.75,
    paddingTop: 10
  },
  loadingContainer: {
    height: SCREEN_HEIGHT / 1.75,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent'
  },
  lottieStyle: {
    width: '50%'
  },
  webviewContainer: {
    backgroundColor: 'transparent'
  }
})
